<template>
  <div class="part-3">
    <div
      style="margin-top:2px;text-align: left;"
      v-if="fileListArr.length == 0 && pageStatus == 2"
    >
      无附件
    </div>
    <div
      class="list"
      :class="{
        'hide-btn': pageStatus == 2,
        disabled: fileListArr.length >= 5
      }"
    >
      <el-upload
        :headers="headers"
        class="files-upload"
        :action="fileUpload"
        multiple
        accept=".pdf"
        :limit="limit"
        :before-remove="handleRemove"
        :on-change="handleChange"
        :on-error="handleError"
        :before-upload="beforeUpload"
        :file-list="fileListArr"
        with-credentials
        :disabled="pageStatus == 2"
        :on-preview="clickFile"
        :on-exceed="handleExceed"
      >
        <div
          class="add-file"
          @click.stop="() => {}"
          v-if="fileListArr.length >= limit"
        >
          <el-button
            :disabled="fileListArr.length >= limit"
            style="margin-left:5px;display:block;"
            size="small"
            type="primary"
          >
            选择文件
          </el-button>
        </div>
        <div class="add-file" v-else>
          <el-button
            style="margin-left:5px;display:block;"
            size="small"
            type="primary"
          >
            添加文件
          </el-button>
        </div>
        <div slot="tip" class="el-upload__tip">
          只能上传PDF文件，文件最大{{ maxSize }}M
        </div>
      </el-upload>
    </div>
  </div>
</template>
<script>
import { taxPayment, fileUpload } from '@/api/ajax';
import { getToken } from '@/tools/auth';
import Config from '@/config/index';
export default {
  props: {
    fileList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    pageStatus: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      fileListArr: [],
      fileUpload: taxPayment.fileUploadTaxPaymentAnnex,
      // fileUpload,
      limit: 10,
      maxSize: 50,
      headers: {
        [Config.token]: getToken()
      }
    };
  },
  methods: {
    beforeUpload(file) {
      this.$emit('before-upload', file);
      if (file.type.slice(-3) != 'pdf') {
        this.$message.error('请上传pdf文件');
        return false;
      }
      if (file.size > this.maxSize * 1024 * 1024) {
        this.$message.error(`上传文件大小不得超过${this.maxSize}M`);
        return false;
      }
    },
    handleExceed() {
      this.$message.error(
        `上传文件数量不超过${this.limit}个,还可添加${this.limit -
          this.fileListArr.length}个文件`
      );
    },
    handleError() {
      this.$emit('on-error');
    },
    handleChange(file, fileList) {
      const arr = [];
      const allUpload = fileList.every(item => {
        const { data, status, message } = item.response || {};
        const { fileUrl } =
          Object.prototype.toString.call(data) == '[object Object]' ? data : {};
        arr.push({
          ajaxMessage: message,
          ajaxStatus: status,
          name: item.name,
          url: fileUrl || item.url
        });
        return item.response || item.status == 'success';
      });
      if (allUpload) {
        const info = arr.find(i => i.ajaxStatus && i.ajaxStatus != 1);
        if (info && info.ajaxMessage) {
          this.$message.error(info.ajaxMessage);
        }
        this.fileListArr = arr.filter(
          i => (!i.ajaxStatus || i.ajaxStatus == 1) && i.url
        );
        this.$emit('success', [...this.fileListArr]);
      }
    },
    handleRemove(file, fileList) {
      this.fileListArr = fileList;
      this.$emit('success', fileList);
    },
    clickFile(file) {
      if (this.pageStatus == 2) {
        this.$downloadFile(file.name, file.url);
      }
    }
  },
  mounted() {
    this.fileListArr = [...this.fileList];
  },
  watch: {
    fileList: {
      handler: function(newV) {
        this.fileListArr = [...(newV || [])];
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.part-3 {
  .list {
    // &.disabled {
    //   .add-file {
    //     display: none;
    //   }
    // }
    &.hide-btn {
      margin-top: -40px;
      .add-file {
        display: none;
      }
    }
  }
}
.files-upload {
  text-align: left;
}
</style>
